/**
 * 存档管理
 * localStorage 读写
 */

import type { PlayerState } from './Player';

const SAVE_KEY = 'xiu_game_save';
const SAVE_VERSION = 1;

interface SaveData {
  version: number;
  timestamp: number;
  player: PlayerState;
}

/**
 * 保存游戏
 */
export function saveGame(player: PlayerState): boolean {
  try {
    player.lastSaveTime = Date.now();
    const saveData: SaveData = {
      version: SAVE_VERSION,
      timestamp: Date.now(),
      player,
    };
    localStorage.setItem(SAVE_KEY, JSON.stringify(saveData));
    return true;
  } catch (e) {
    console.error('保存失败:', e);
    return false;
  }
}

/**
 * 读取存档
 */
export function loadGame(): PlayerState | null {
  try {
    const raw = localStorage.getItem(SAVE_KEY);
    if (!raw) return null;

    const saveData: SaveData = JSON.parse(raw);

    if (saveData.version !== SAVE_VERSION) {
      console.warn('存档版本不匹配，可能需要迁移');
      // 后续可在此处添加版本迁移逻辑
    }

    return saveData.player;
  } catch (e) {
    console.error('读档失败:', e);
    return null;
  }
}

/**
 * 删除存档
 */
export function deleteSave(): boolean {
  try {
    localStorage.removeItem(SAVE_KEY);
    return true;
  } catch (e) {
    console.error('删档失败:', e);
    return false;
  }
}

/**
 * 检查是否存在存档
 */
export function hasSave(): boolean {
  return localStorage.getItem(SAVE_KEY) !== null;
}

/**
 * 获取存档时间
 */
export function getSaveTime(): number | null {
  try {
    const raw = localStorage.getItem(SAVE_KEY);
    if (!raw) return null;
    const saveData: SaveData = JSON.parse(raw);
    return saveData.timestamp;
  } catch {
    return null;
  }
}
